<template><div><h1 id="mwst-codes" tabindex="-1"><a class="header-anchor" href="#mwst-codes"><span>MWST-Codes</span></a></h1>
<p>MWST-Codes — Definition der MWST-Codes</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die im System verfügbaren MWST-Codes zur Validierung der Benutzereingaben. Im Artikelstamm können mehrere MWST-Code aktiv vorkommen. Das System unterstützt auch die Abrechnung mehrerer MWST-Sätze innerhalb eines Auftrages und gegenüber den Steuerbehörden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Mehrwertsteuersätze</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>MWSt</dt>
<dd>MWST-Code, 1-stellig, alphanumerisch</dd>
<dt>Mand</dt>
<dd>Mandant</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung des MWST-Codes</dd>
<dt>Satz</dt>
<dd>Mehrwertsteuersatz, numerisch, 3-stellig mit 2 Dezimalstellen</dd>
<dt>Basis</dt>
<dd>Basis für die Mehrwertsteuerberechnung in Prozent. Beispiel: entspricht der Verkaufspreis 100 % (inkl. MWST), errechnet das Programm die MWST aufgrund des Verkaufspreises als Bruchteil des Verkaufspreises, auch abhängig vom Parameter I/E</dd>
<dt>I/E</dt>
<dd>I = inklusive: Der Verkaufspreis im Artikelstamm ist inklusive MWST<br>E = exklusive: auf den im Artikelstamm gespeicherten Verkaufspreis wird der Mehrwertsteuersatz noch dazugerechnet.</dd>
<dt>MWSt Fibu</dt>
<dd>MWST-Code, der an externe Buchhaltung übergeben wird. Abhängig von den Definitionen in der Schnittstelle zur externen Finanzbuchhaltung sind hier Eingaben zu definieren. 3-stellig, alphanumerisch</dd>
<dt>MWSt Exp</dt>
<dd>Beim Export ins Ausland wird die MWST immer abgezogen (es finden keine MWST-Einzelbuchungen statt). Dieser Code ersetzt beim Export den MWST-Code aus dem Artikelstamm. Beispiele: Ist der Code in Spalte &quot;E&quot; derselbe, wie in Spalte &quot;MWSt&quot; z.B. 7.5 %, so wird die MWST vom Verkaufspreis abgezogen, der Kunde bezahlt einen um 7.5 % tieferen Preis. Entspricht der Code in der Spalte &quot;E&quot; dem MWST-Satz 0 %, so wird in die Rechnung der Verkaufspreis aus dem Artikelstamm übernommen.</dd>
<dt>Konto</dt>
<dd>Konto für MWST, das an externe Buchhaltung übergeben wird</dd>
<dt>Kostenstelle</dt>
<dd>Kostenstelle für MWST, die an externe Buchhaltung übergeben wird</dd>
<dt>Kostenträger</dt>
<dd>Kostenträger für MWST, der an externe Buchhaltung übergeben wird</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="Kapitel 6. Buchhaltung">Buchhaltung</RouteLink>--&gt;</p>
</div></template>


